export default {"src":"/_next/static/media/tooltip.41d795af.svg","height":16,"width":16};